import React, { useEffect } from "react";
import FromToPage from "../../components/FromToPage";
import langData from "../../lang/data";
import { useDispatch, useSelector } from "react-redux";
import style from "./style..module.css";
import { getPrivacyPolicy } from "../../store/privacyPolicy/privacyPolicyFetch";
import PageSeo from "../../components/PageSeo";

const PrivacyPolicy = () => {
  const { currentLanguage } = useSelector(({ main }) => main);
  const { isLoading, policyList } = useSelector(
    (state) => state.PrivacyPolicySlice
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPrivacyPolicy());
  }, [dispatch]);

  const html = policyList?.["description_" + currentLanguage] || "";

  return (
    <>
      <PageSeo pageKey="privacy" />
      <div className="wrapper">
        <FromToPage
          pages={[
            {
              label: langData.titles.PrivacyPolicy[currentLanguage],
              value: "/privacy",
              active: true,
            },
          ]}
        />
        <div className={style.privacy_policy_body}>
          <h1>{langData.titles.PrivacyPolicy[currentLanguage]}</h1>
          {!isLoading && html ? (
            <div
              className={style.privacy_policy_description}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
